import ProductList from "../components/ProductList.tsx";
import {Container, Tab, Tabs} from "@mui/material";
import {useContext, useEffect, useState} from "react";
import ProductContext from "../contexts/ProductContext.tsx";
import {IProduct} from "../models/IProduct.ts";
import {useParams} from "react-router-dom";
import {useTranslation} from "react-i18next";

const CategoryPage = () => {
    const {t} = useTranslation();
    const {category} = useParams();
    const {products} = useContext(ProductContext);
    const [label, setLabel] = useState<string>();
    const [productsInCategory, setProductsInCategory] = useState<IProduct[]>([]);

    useEffect(() => {
        if (products) {
            const filteredProducts = products.filter(product => product.category === category);
            setProductsInCategory(filteredProducts);
        }
        switch (category) {

            case 'halsketten':
                setLabel(`${t('NAV_NECKLACES_TEXT')}`)
                break
            case 'armbänder':
                setLabel(`${t('NAV_BRACELETS_TEXT')}`)
                break
            case 'mysteryBoxen':
                setLabel(`${t('MYSTERY_BOXES_TEXT')}`)
                break
            case 'ohrringe':
                setLabel(`${t('NAV_EARRINGS_TEXT')}`)
                break
            case 'ringe':
                setLabel(`${t('NAV_RINGS_TEXT')}`)
                break
            case 'sterlingSilber':
                setLabel(`${t("STERLING_SILVER")}`)
                break
            case 'stainlessSteel':
                setLabel(`${t("STAINLESS_STEEL")}`)
                break
            case 'customs' :
                setLabel(`${t('NAV_CUSTOMS_TEXT')}`)
        }
    }, [products, category]);

    return (
        <Container>
            <Tabs value={0} centered>
                <Tab label={label} sx={{textTransform: "none"}}/>
            </Tabs>
            <ProductList products={productsInCategory} category={category}/>
        </Container>
    )
}

export default CategoryPage